"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = require("zod");
const scheduledEvent = zod_1.z.object({
    eventId: zod_1.z.number().optional(),
    pulseEventId: zod_1.z.number().optional(),
});
exports.requestSchema = zod_1.z.array(scheduledEvent);
exports.path = '/irrigation-scheduler-events-stop';
//# sourceMappingURL=index.js.map